import React from 'react';
import { cn } from '@/lib/utils';

/** Wordmark only. The collapsed rail shows nothing, so `compact` renders null. */
const RevyMark: React.FC<{ compact?: boolean; className?: string }> = ({
  compact = false,
  className,
}) => {
  if (compact) return null;

  return (
    <span
      aria-label="REVY"
      className={cn(
        'select-none font-display text-xl font-semibold leading-none tracking-[-0.02em] text-foreground',
        className,
      )}
    >
      REVY
    </span>
  );
};

export default RevyMark;
